'use strict';

// 访问接口的总方法名称
const http_method = '/Data_All'  //配置访问方法 base64二次转码+临时随机字节 转码传输
const http_downfile = '/DownLoadFile' 


// 访问接口的总方法口令
const http_token = 'wlgl_v2'     //配置访问口令

export default {
  http_method,
  http_token,  
  http_downfile
}
